import { NetworkRequestData } from '../types'

import { DEVTOOLS_REQUEST_TRACKER_MAX_ENTRIES } from './constants'

interface RequestTracker {
  addRequest: (request: NetworkRequestData) => void
  clearRequests: () => void
  getRequests: () => NetworkRequestData[]
  subscribe: (callback: () => void) => () => void
}

class RequestTrackerImpl implements RequestTracker {
  private requests: NetworkRequestData[] = []
  private subscribers: Set<() => void> = new Set()
  private readonly MAX_REQUESTS = DEVTOOLS_REQUEST_TRACKER_MAX_ENTRIES

  addRequest(request: NetworkRequestData): void {
    // Add new request at the end
    this.requests = [...this.requests, request]

    // Keep only the most recent MAX_REQUESTS requests
    if (this.requests.length > this.MAX_REQUESTS) {
      this.requests = this.requests.slice(-this.MAX_REQUESTS)
    }

    this.notifySubscribers()
  }

  clearRequests(): void {
    this.requests = []
    this.notifySubscribers()
  }

  getRequests(): NetworkRequestData[] {
    return [...this.requests]
  }

  subscribe(callback: () => void): () => void {
    this.subscribers.add(callback)
    return () => {
      this.subscribers.delete(callback)
    }
  }

  private notifySubscribers(): void {
    this.subscribers.forEach((cb) => cb())
  }
}

export const requestTracker = new RequestTrackerImpl()
